/**
 * Service: subscriptionsApi
 */
angular.module('acme.common.service.subscriptionsApi', [
  'acme.common.factory.QueryStringBuilder',
  'acme.common.factory.apiVersion'
])
.service('SubscriptionsApiService', [ '$http', 'QueryStringBuilderFactory', 'ApiVersionFactory', function($http, QueryStringBuilderFactory, ApiVersionFactory) {

    return {

      service: '',
      paymentPlanService: '',

      init: function(endpoint) {
        this.service = endpoint + '/recurring/membership';
        this.customer.service = endpoint + '/recurringpaymentplan/customer'
        this.paymentPlanService = endpoint + '/recurring/paymentplan';
        return this;
      },

      list: function(props) {
        var q = '',
          av = new ApiVersionFactory();

        if (props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: [
                'pageSize',
                'page',
                'sortField',
                'sortDirection',
                'startDate',
                'endDate',
                'status',
                'filterType'
              ]
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'get',
          // url: '/assets/data/subscriptions.list.json'
          url: av.init({url: this.service + '/details', version: 'v2'}) + q
        });
      },

      detail: function (id) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'get',
            url: av.init({url: this.service + '/' + id + '/details', version: 'v2'})
        });
      },

      optOut: function(id) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'put',
          url: av.init({url: this.paymentPlanService + '/' + id + '/cancel?saleChannel=insideSalesIndividual', version: 'v2'})
        });
      },

      customer: {

        service: '',

        detail: function (id) {
          var av = new ApiVersionFactory();
  
          return $http({
            method: 'get',
              url: av.init({url: this.service + '/' + id, version: 'v2'})
          });
        },
      }

    };

}]);
